import React from 'react';
import Link from 'next/link';
import { ListingNavigationProps } from './ListingNavigation.types';
import { NavigationLink } from './ListingNavigation.styles';
import { ArrowheadLeftSmall } from '@blueprint/icons';
import {
    trackBackToSearchClick,
    trackSimilarPropertiesClick
} from './ListingNavigation.tracking';
import { BackToResultsLinkType } from 'graphql.generated';

const ListingNavigation = ({ data }: ListingNavigationProps) => {
    const { linkType, uri } = data;

    const cameFromSearch = linkType === BackToResultsLinkType.Personalised;

    const handleBackClick = () => {
        if (cameFromSearch) {
            trackBackToSearchClick();
        } else {
            trackSimilarPropertiesClick();
        }
    };

    return (
        <Link href={uri || '/search'} passHref prefetch={false}>
            <NavigationLink
                variant="tertiary"
                data-testid={'listingNav-link'}
                onClick={handleBackClick}
            >
                <ArrowheadLeftSmall />
                {cameFromSearch
                    ? 'Back to search results'
                    : 'See similar properties'}
            </NavigationLink>
        </Link>
    );
};

export default ListingNavigation;
